import { jsx as _jsx } from "react/jsx-runtime";
import ApplicationStepperView from './ApplicationStepper';
import ForteApplicationProvider from '../Common/ForteApplicationProvider';
export default function ApplicationStepper() {
    return (_jsx(ForteApplicationProvider, { children: _jsx(ApplicationStepperView, {}) }));
}
